import { useTranslation } from "react-i18next";
import { PageHeader } from "../../commons/component/PageHeader/PageHeader";
import MedicalSpecialtiesListComponent from "../../components/MedicalSpecialties/MedicalSpecialties.List/MedicalSpecialtiesList.Component";
import IdentifierTypesListComponent from "../../components/Persons/IdentifierTypes/IdentifierTypes.List.Component";

const MoreConfigurationsPage = () => {
    const { t } = useTranslation();

    return (
        <>
            <PageHeader title={t('moreConfigurations.title')} />
            <div className="header">
                <h2>{t('moreConfigurations.specialties')}</h2>
            </div>
            <div className="Section">
                <MedicalSpecialtiesListComponent />
            </div>
            {/* Tipos de identificador de personas (spec 011): incluye el "CUIT" que usan los proveedores. */}
            <div className="header">
                <h2 id="more-settings-identifier-types">{t('moreConfigurations.identifierTypes')}</h2>
            </div>
            <section className="Section" aria-labelledby="more-settings-identifier-types">
                <IdentifierTypesListComponent />
            </section>
        </>
    )
}

export default MoreConfigurationsPage;
